/* eslint-disable react/prop-types */
import React from 'react';

const FullSizeCardDisplay = ({ stroke, ...props }) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="63"
      height="63"
      rx="7.5"
      fill="#F4F6F9"
      stroke={stroke || '#A6A7B0'}
    />
    <rect x="16" y="9" width="32" height="46" fill="#D9D9D9" />
    <rect x="16" y="21" width="32" height="8" fill="white" />
  </svg>
);

export default FullSizeCardDisplay;
